<template>
    <div class="log-detail">
        <transition name="popup">
            <div class="popup-mask" v-if="isShowPopup == true" @click.self="closePopup()">
                <div class="popup-content">
                    <i class="close bi bi-x" @click="closePopup()"></i>
                    <div class="type-filter">
                        <div class="type-list">
                            <ul>
                                <li v-for="(item, index) in typeFilters" :key="index" :class="{'item': true, 'selected': item.selected}" 
                                    @click="item.selected = !item.selected">{{ item.filter_name }}</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <table id="logDetailTable">
                            <tr>
                                <th class="w-25">{{ comp_name }}</th>
                                <th>日期</th>
                                <th>存量上限</th>
                                <th>累積已使用存量</th>
                                <th>每月AI可查詢次數</th>
                                <th>已使用查詢次數</th>
                                <th>Remark</th>
                            </tr>
                            <tr class="logDetailRow" v-for="logRec in log_data" v-show="(logRec.log_type == 1 && checkFilter(1)) || (logRec.log_type == 2 && checkFilter(2)) 
                                || (logRec.log_type == 3 && checkFilter(3))" :key="logRec.id">

                                <td>{{ logRec.log_type_name }}</td>
                                <td>{{ logRec.log_datetime.split(' ')[0] }}</td>
                                <td>{{ displayStorageTotal(logRec) }}</td>
                                <td>{{ displayStorageUsed(logRec) }}</td>
                                <td>{{ displaySearchLimit(logRec) }}</td>
                                <td>{{ displaySearchUsed(logRec) }}</td>
                                <td>{{ logRec.remark }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

export default {
    name: 'logDetail',

    props: {
        log_data: { type: Array },
        comp_name: { type: String, default: '' },
    }, 
    data() {
        return {
            isShowPopup: true,
            
            typeFilters: [],
        };
    },
    methods: {

      formatBytes(bytes) {
        if (bytes === 0) return '0 KB';
        const k = 1024;
        // const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const sizes = ['KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        if (i > 3) {
          return parseFloat((bytes / Math.pow(k, 3)).toFixed(2)) + ' ' + sizes[3];
  
        } else {
          return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        }
      },

      displayStorageTotal(logRec) {
        if (logRec.log_type == 1) {
            return this.formatBytes(logRec.storage_total);
        } else {
            return '';
        }
      },

      displayStorageUsed(logRec) {
        if (logRec.log_type == 2) {
            return this.formatBytes(logRec.storage_used);
        } else {
            return '';
        }
      },

      displaySearchLimit(logRec) {
        if (logRec.log_type == 1 || logRec.log_type == 3) {
            return logRec.search_limit.toLocaleString();
        } else {
            return '';
        }
      },

      displaySearchUsed(logRec) {
        if (logRec.log_type == 2) {
            return logRec.search_used.toLocaleString();
        } else {
            return '';
        }
      },

      checkFilter(logType) {
        if (this.typeFilters.filter(k => k.selected == true && k.type == logType).length > 0) {
            return true;
        } else {
            return false;
        }
      },

        closePopup() {
            this.isShowPopup = false;
            this.$emit('toggleLogDetailPopup');
        },

    },

    mounted() {
        this.typeFilters.push({selected: true, type:1, filter_name:"更改用量規則"});
        this.typeFilters.push({selected: true, type:2, filter_name:"上月用量記錄"});
        this.typeFilters.push({selected: true, type:3, filter_name:"重設用量"});
    },
}
</script>

<style scoped>

.popup-mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
}

.popup-mask .popup-content {
    position: absolute;
    width: 60%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    background: #fff;
    overflow: hidden;
    z-index: 1000;
    border-radius: 30px;
    padding: 20px;
    min-width: 530px;
    max-height: 100%;
    overflow-y: scroll;
}

.popup-mask .popup-content::-webkit-scrollbar {
    display: none;
}

.popup-mask .popup-content .close {
    border-radius: 40px;
    width: 18px;
    font-size: 20px;
    float: right;
    color: gray;
    position: absolute;
    right: 23px;
    top: 13px;
    cursor: pointer;
}

table, th, td {
  border:1px solid black;
  text-align: left;
  padding: 2px;
}

table {
    width: 95%;
}

.type-filter .type-list {
    margin-top: 20px;
}

.type-filter .type-list ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
}

.type-filter .type-list ul li {
    list-style-type: none;
    background-color: white;
    margin: 0px 8px 5px 0px;
    border-radius: 20px;
    padding: 0 15px;
    color: #F05A27;
    border: 1px solid #F05A27;
    font-size: 12px;
    font-weight: bold;
}

.type-filter .type-list ul li.selected {
    background-color: peachpuff;
}


</style>